// extracted by mini-css-extract-plugin
export default {"ListItemTitle_Truncated":"AttestationsList-module__ListItemTitle_Truncated--wqaqJ"};